// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ayXdY","header":"styles_header__UKxFI","content":"styles_content__oEdnF","terms":"styles_terms__z7meS"};